<template>
  <div>
    <div class="top-breadcrumb">
      <ol class="breadcrumb" style="background-color: white">
        <li class="breadcrumb-item" style="margin-left: 15px">
          <router-link to="" style="color: #8cc63f !important">
            Portfolio Management
          </router-link>
        </li>
        <li class="breadcrumb-item">
          <router-link
            style="color: #8cc63f !important"
            :to="'/' + authUser.userable_type + '/projects/valuations'"
            >Valuations</router-link
          >
        </li>
      </ol>
    </div>
    <div
      style="display: flex; justify-content: center; margin-top: 60px"
      class="col-12"
    >
      <span
        class="col-1"
        style="
          display: flex;
          align-items: center;
          justify-content: center;
          color: gray;
        "
      >
        <i
          class="fa fa-filter"
          style="font-size: 15px; color: #8cc63f; margin-right: 5px"
        ></i>
        Filter
      </span>
      <span class="col-3">
        <date-range-picker
          ref="picker"
          :locale-data="{
            firstDay: 1,
            format: 'dd-mm-yyyy',
            applyLabel: 'Apply',
            cancelLabel: 'Cancel',
          }"
          :timePicker="false"
          :showDropdowns="true"
          :autoApply="true"
          v-model="dateRange"
          @update="filter()"
          :linkedCalendars="true"
          style="width: 100%"
        >
        </date-range-picker>
      </span>
      <span class="col-1">
        <button
          style="font-size: 14px"
          type="button"
          class="btn btn-info"
          @click="clearDateRage()"
        >
          Clear
        </button>
      </span>
      <span class="col-4">
        <select
          class="custom-select"
          v-model="account_id"
          @change="filter()"
          :showClearButton="true"
        >
          <option v-if="!account_id" :value="null" disabled selected>
            Select a Project ID
          </option>
          <option v-else :value="null" selected>Clear Selection</option>
          <option
            v-for="project in projects"
            :key="project.code"
            :value="project.account_id"
          >
            {{ project.code }}
            ({{ project.name }})
          </option>
        </select>
      </span>
    </div>
    <div style="display: flex; justify-content: center; margin-top: 50px">
      <div
        style="display: flex; justify-content: center; cursor: pointer"
        @click="toggleCreateProjectValuationModal()"
      >
        <div>
          <i
            class="fa fa-plus-circle"
            style="font-size: 90px; color: #8cc63f; margin-right: 5px"
          ></i>
        </div>
        <div
          style="
            display: flex;
            align-items: center;
            flex-direction: column;
            margin: 0;
            justify-content: center;
            margin-left: 10px;
          "
        >
          <p
            style="
              margin: 0px;
              font-size: 40px;
              margin-bottom: 5px;
              color: #8cc63f;
            "
          >
            ADD
          </p>
          <p style="margin: 0; color: #8cc63f; font-size: 14px">
            new Valuation
          </p>
        </div>
      </div>
    </div>
    <div style="display: flex; justify-content: center; margin-top: 50px">
      <md-card
        class="md-card-stats"
        style="
          background-color: white;
          max-width: 90%;
          border-radius: 15px;
          padding: 40px;
        "
      >
        <spinner v-if="searchingValuations" />
        <vue-good-table
          v-else
          :columns="valuationColumns"
          :rows="valuations"
          max-height="450px"
        >
          <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field == 'code'">
              <router-link
                style="color: #00a5e3 !important"
                :to="
                  '/' +
                  authUser.userable_type +
                  '/projects/valuation/' +
                  props.row.code +
                  '/update/' +
                  props.row.id
                "
              >
                {{ props.formattedRow[props.column.field] }}</router-link
              >
            </span>
            <span v-else-if="props.column.label == 'Amount'">
              {{ fixNumberView(props.row.amount) }}
            </span>
            <span v-else-if="props.column.label == 'Final Amount (USD)'">
              {{ getUSDAmount(props.row) }}
            </span>
          </template></vue-good-table
        >
      </md-card>
    </div>
    <valuation-modal
      :active="showProjectValuationModal"
      :actionType="actionModalType"
      :activeProjectValuation="activeProjectValuation"
      @saveRequest="handleSave"
      @closeRequest="
        actionModalType == 'createModal'
          ? toggleCreateProjectValuationModal()
          : toggleUpdateProjectValuationModal()
      "
    />
  </div>
</template><script>
import sweetAlert from "sweetalert2";
import { mapState } from "vuex";
import moment from "moment";
import ProjectValuationsFilter from "../../filters/ProjectValuationsFilter";
import DateRangePicker from "vue2-daterange-picker";
import Spinner from "vue-simple-spinner";
import ValuationModal from "./components/modals/valuationModal.vue";

export default {
  name: "projectValuations",
  data() {
    return {
      actionModalType: null,
      showProjectValuationModal: false,
      activeProjectValuation: null,
      valuationColumns: [
        {
          label: "#",
          field: this.valuationIndex,
          sortable: false,
        },
        {
          label: "Project ID",
          field: "project_details.code",
        },
        {
          label: "Year",
          field: "year",
          type: "number",
        },
        {
          label: "Quarter",
          field: "quarter_number",
        },
        // {
        //   label: "Amount",
        //   field: "amount",
        // },
        // {
        //   label: "Currency",
        //   field: "currency.code",
        // },
        // {
        //   label: "Exchange Rate	",
        //   field: "exchange_rate",
        // },
        {
          label: "Valuation (USD)",
          field: this.calculateUSDAmount,
          type: "number",
        },
        {
          label: "Date",
          field: "date",
        },
      ],
      valuationList: [],
      type: null,
      valuation_id: null,
      account_id: null,
      dateRange: {
        startDate: null,
        endDate: null,
      },
    };
  },
  components: {
    DateRangePicker,
    Spinner,
    ValuationModal,
  },
  created: function () {
    this.$store.dispatch("searchProjects");
    var valuationsFilter = ProjectValuationsFilter();
    valuationsFilter.appends = ["project_details"];
    this.$store.dispatch("searchProjectValuations", {
      filter: valuationsFilter,
      resultMode: "default",
    });
  },

  computed: {
    ...mapState({
      authUser: (state) => state.userStore.authUser,
      valuations: (state) =>
        state.projectValuationStore.projectValuationSearch.projectValuations,
      projects: (state) => state.projectStore.projectSearch.projects,
      searchingValuations: (state) =>
        state.projectValuationStore.projectValuationSearch
          .searchingProjectValuations,
      createValuationStatus: (state) =>
        state.projectValuationStore.projectValuationCreate
          .createProjectValuationStatus,
    }),
    moment() {
      return moment;
    },
  },
  methods: {
    init() {
      this.actionModalType = null;
      this.showProjectValuationModal = false;
      this.activeProjectValuation = null;
      var valuationsFilter = ProjectValuationsFilter();
      valuationsFilter.appends = ["project_details"];
      this.$store.dispatch("searchProjectValuations", {
        filter: valuationsFilter,
        resultMode: "default",
      });
    },
    valuationIndex(valuation) {
      return valuation.originalIndex + 1;
    },
    calculateUSDAmount(valuation) {
      // console.log(valuation);
      return valuation.value * valuation.exchange_rate;
    },
    getUSDAmount(valuation) {
      var amount = this.calculateUSDAmount(valuation);
      return this.fixNumberView(amount);
    },
    fixNumberView(value) {
      const numFor = Intl.NumberFormat("en-US", {
        minimumFractionDigits: 0,
        maximumFractionDigits: 4,
      });
      return value < 0
        ? "(" + Math.abs(value).toLocaleString() + ")"
        : numFor.format(value);
    },
    filter() {
      var valuationsFilter = ProjectValuationsFilter();
      valuationsFilter.text = this.keyword;
      if (this.valuation_id) {
        valuationsFilter.ids = [this.valuation_id];
      }
      if (this.project_id) {
        valuationsFilter.project_ids = [this.project_id];
      }
      if (this.dateRange.startDate != null && this.dateRange.endDate != null) {
        let start_date = moment(this.dateRange.startDate).format("YYYY-MM-DD");
        let end_date = moment(this.dateRange.endDate).format("YYYY-MM-DD");
        let date_range = { startDate: start_date, endDate: end_date };
        valuationsFilter.dateRange = date_range;
      }
      valuationsFilter.appends = ["project_details"];
      this.$store.dispatch("searchProjectValuations", {
        filter: valuationsFilter,
        resultMode: "default",
      });
    },
    clearDateRage() {
      this.dateRange = {
        startDate: null,
        endDate: null,
      };
      this.filter();
    },
    toggleCreateProjectValuationModal() {
      this.showProjectValuationModal = !this.showProjectValuationModal;
      this.showProjectValuationModal
        ? (this.actionModalType = "createModal")
        : null;
    },
    toggleUpdateProjectValuationModal(projectValuation = null) {
      this.showProjectValuationModal = !this.showProjectValuationModal;
      if (this.showProjectValuationModal) {
        this.actionModalType = "updateModal";
        this.activeProjectValuation = projectValuation;
      } else {
        this.actionModalType = null;
        this.activeProjectValuation = null;
      }
    },
    formValidation(valuation) {
      const result = { isValid: true, message: "" };
      result.message += "Please fill all required fields";
      let missingFieldsString = "";

      if (!valuation.year) {
        missingFieldsString += "Year field is empty, ";
        result.isValid = false;
      }
      if (!valuation.quarter_number) {
        missingFieldsString += "Quarter field is empty, ";
        result.isValid = false;
      }
      if (!valuation.project_id) {
        missingFieldsString += "Project is not selected, ";
        result.isValid = false;
      }
      if (!valuation.value) {
        missingFieldsString += "Value field is empty, ";
        result.isValid = false;
      }
      if (!valuation.exchange_rate) {
        missingFieldsString += "Exchange rate field is empty, ";
        result.isValid = false;
      }

      if (missingFieldsString.length > 0) {
        // remove trailing comma
        missingFieldsString = missingFieldsString.substring(
          0,
          missingFieldsString.length - 2
        );
        result.message += ` (${missingFieldsString})`;
      }
      return result;
    },
    handleSave(projectValuation) {
      const { isValid, message } = this.formValidation(projectValuation);
      if (!isValid) {
        sweetAlert({
          title: "Error",
          text: message,
          type: "error",
          confirmButtonText: "Return",
        });
        return;
      }
      if (this.actionModalType == "createModal") {
        this.createProjectValuation(projectValuation);
      } else {
        this.updateProjectValuation(projectValuation);
      }
    },
    createProjectValuation(projectValuation) {
      this.$store.dispatch("createProjectValuation", projectValuation);
    },
    // deleteValuation(id) {
    //   sweetAlert({
    //     title: "Confirmation",
    //     text: "Are you sure you want to delete this valuation?",
    //     icon: "warning",
    //     showCancelButton: true,
    //     confirmButtonText: "Yes",
    //     cancelButtonText: "No",
    //   }).then((result) => {
    //     /* Read more about isConfirmed, isDenied below */
    //     if(result.value) {
    //       this.$store.dispatch("deleteValuation", id);
    //     }
    //   });
    // },
  },
  watch: {
    createValuationStatus() {
      if (this.createValuationStatus == "success") {
        sweetAlert({
          title: "Success",
          text: "Project valuation has been created successfully",
          icon: "success",
          confirmButtonText: "Done",
        }).then(() => {
          this.init();
        });
      } else if (this.createValuationStatus == "failed") {
        sweetAlert({
          title: "Failed",
          text: "Project valuation creation has failed",
          IntersectionObserver: "error",
          confirmButtonText: "Return",
        });
      }
    },
  },
};
</script> 
 <style>
.md-ripple {
  padding: 0px !important;
}
.table.vgt-table {
  font-size: 20px;
}
.custom-select {
  background-color: #fafaf7;
}
.form-control {
  border: 1px solid #ced4da !important;
  background-image: none;
  border-radius: 5px !important;
  background-color: rgb(250, 250, 247) !important;
}
.vgt-table.bordered td,
.vgt-table.bordered th {
  border: hidden !important;
}

.vgt-table.bordered td,
.vgt-table.bordered th {
  border: hidden !important;
  background: none;
}

.vgt-inner-wrap {
  box-shadow: none !important;
}
.vgt-left-align {
  text-align: center;
}
.vgt-right-align {
  text-align: center;
}
.vgt-table.bordered td,
.vgt-table.bordered th {
  background: #fff;
}

table.vgt-table thead th {
  position: -webkit-sticky; /* for Safari */
  position: sticky;
  top: 0;
}

/* ===== Scrollbar CSS ===== */
/* Firefox */
* {
  scrollbar-width: auto;
  scrollbar-color: #dbd5dc #ffffff;
}

/* Chrome, Edge, and Safari */
*::-webkit-scrollbar {
  width: 12px;
}

*::-webkit-scrollbar-track {
  background: #ffffff;
}

*::-webkit-scrollbar-thumb {
  background-color: #dbd5dc;
  border-radius: 10px;
  border: 3px solid #ffffff;
}
</style>


// WEBPACK FOOTER //
// resources/js/pages/admin/projectsValuations.vue